import { useMemo } from 'react';

import { AccessType } from 'services/access.service';

import { ReactComponent as LockIcon } from 'assets/ui/lock.svg';
import { ReactComponent as UnlockIcon } from 'assets/ui/unlock.svg';
import { ReactComponent as ProtectIcon } from 'assets/ui/protect.svg';

interface Props {
  accessType?: AccessType;
}

export const HeaderAccessIco = ({ accessType }: Props) => {
  return useMemo(() => {
    switch (accessType) {
      case AccessType.Unrestricted:
        return <UnlockIcon />;
      case AccessType.Protected:
        return <ProtectIcon />;
      default:
        return <LockIcon />;
    }
  }, [accessType]);
};
